import React, { Component } from 'react'
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    // Display fallback UI
    this.setState({ hasError: true });
    // You can also log the error to an error reporting service
    // console.log(error, info);
  }

  render() {
    const mystyle = {
      textAlign: "center",
      padding: "50px",
      zIndex: '2147483648'
    }

    if (this.state.hasError) {
      
      // You can render any custom fallback UI
      let template = <div className='something_wrong' style={mystyle}>
        <h1 style={{padding: '15px'}}>Something went wrong.</h1>
        <button onClick={() => window.location.reload(false)}>Click to reload!</button>
      </div>
      return template

    }
    return this.props.children;
  }
}

export default ErrorBoundary